import {
  capitalizeFirstLetter,
  notifyError,
  notifySuccess,
} from "../../helpers/helpers";
import { auction } from "../config/urlConfig";
import { singleAuctionDetails } from "./singleAuction";

export const offerCreate =
  (
    id,
    object,
    imageFileList,
    setKeyValue,
    setImageFileList,
    setCreateOffer,
    setValues
  ) =>
  async (dispatch) => {
    const formDatas = new FormData();

    const data = [
      { key: "quantity", value: String(object?.quantity) },
      {
        key: "location",
        value: JSON.stringify({
          latitude: object?.location?.latitude,
          longitude: object?.location?.longitude,
          address: object?.location?.address,
        }),
      },
      { key: "EMDAmount", value: String(object?.EMDAmount) },
      {
        key: "scrapDetails",
        value: JSON.stringify({
          type: object?.productType,
          name: object?.productName,
          quantity: object?.quantity,
          unit: object?.unit,
        }),
      },
      { key: "maximumBid", value: String(object?.maximumBid||0) },
      { key: "minimumBid", value: String(object?.minimumBid||0) },
      { key: "startingPrice", value: String(object?.startingPrice) },
      {
        key: "offerSchedule",
        value: JSON.stringify({
          startingTime: object?.offerStartTime,
          endingTime: object?.offerEndTime,
        }),
      },
      { key: "requiresPCBCertificate", value: JSON.stringify(object?.checked) },
    ];

    data.forEach((item) => formDatas.append(item.key, item.value));

    if (imageFileList?.length > 0) {
      imageFileList?.forEach((item, index) => {
        formDatas.append(`photo${index + 1}`, item);
      });
    }

    if (object?.description !== "") {
      formDatas.append("description", object?.description);
    }

    dispatch({ type: "SHOW_LOADING" });
    try {
      const response = await auction.post(
        `/auction/create/new-offer/${id}`,
        formDatas
      );

      dispatch({ type: "HIDE_LOADING" });
      setKeyValue(Math.floor(Math.random() * 100));
      notifySuccess("Created Lots Successfully");
      setImageFileList([]);
      setCreateOffer({
        EMDAmount: "",
        quantity: "",
        startingPrice: "",
        minimumBid: "",
        maximumBid: "",
        description: "",
        productName: "",
        location: {
          longitude: "",
          latitude: "",
          address: "",
        },
        offerStartTime: "",
        offerEndTime: "",
        unit: "MT",
        checked: false,
        productType: "",
      });
      setValues({
        location: {
          longitude: "",
          latitude: "",
          address: "",
        },
      });
      dispatch({ type: "CREATE_OFFER_AUCTION", payload: response.data });
      dispatch(singleAuctionDetails(id));
    } catch (error) {
      console.error(error);
      notifyError(
        capitalizeFirstLetter(
          error.response ? error.response.data : error.message
        )
      );
      dispatch({ type: "HIDE_LOADING" });
    }
  };
